import React, { Component } from 'react';
import axios from 'axios';
import ModalUpdateRoomEvent from './components/ModalUpdateRoomEvent';
import ModalDeleteRoomEvent from './components/ModalDeleteRoomEvent';

export default class RoomEventPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contests: [],
            roomEvent: null,
            cursor: null,
            isLoading: false,
            // Bộ lọc trạng thái duyệt (KF-29330). '' = tất cả sự kiện, dùng API /list như trước.
            approvalStatus: '',
        };

        this.getContests = this.getContests.bind(this);
        this.handlerUpdate = this.handlerUpdate.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this); // Thêm method mới
        this.handleChangeApprovalStatus = this.handleChangeApprovalStatus.bind(this);
    }

    handleScroll = () => {
        if(this.state.cursor == 'END') return;
        
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (windowHeight + scrollTop >= documentHeight - 100) { // 100px để tránh trường hợp scroll cuối cùng không load được đối với một số máy tính
            if (this.state.isLoading) return;
			console.log(this.state.cursor);
            
            this.setState({ isLoading: true });
            
            axios.post(global.config.apiDomain + this.currentEndpoint(),
                {data: this.currentRequestData(this.state.cursor)}
            )
            .then(res => {
                if (res.data.status === 'OK') {
                    this.setState({
                        contests: [...this.state.contests, ...res.data.data.data],
                        cursor: res.data.data.cursor,
                        isLoading: false
                    })
                }
            })
            .catch(error => {
                console.error('Error loading more data:', error);
                this.setState({ isLoading: false });
            })
        }
    }

    componentDidMount() {
        this.getContests();
        this.setState({
            roomEvent: null,
        })
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    // Lọc "chờ duyệt / đã duyệt / từ chối" đi qua API riêng vì /list không lọc theo trạng thái duyệt.
    currentEndpoint() {
        return this.state.approvalStatus
            ? '/mc-live-room/external/room-event/pending-list'
            : '/mc-live-room/external/room-event/list';
    }

    currentRequestData(cursor) {
        return this.state.approvalStatus
            ? {cursor: cursor, approvalStatus: this.state.approvalStatus}
            : {cursor: cursor};
    }

    handleChangeApprovalStatus(event) {
        this.setState({
            approvalStatus: event.target.value,
            contests: [],
            cursor: null,
        }, this.getContests);
    }

    getContests() {
        axios.post(global.config.apiDomain + this.currentEndpoint(),
			{data: this.currentRequestData(null)}
		)
        .then(res => {
				if (res.data.status === 'OK') {
                this.setState({
                    contests: res.data.data.data,
					cursor: res.data.data.cursor,
					isLoading: false,
                })
            } 
        })
    }

    handlerUpdate(event) {
        let index = event.currentTarget.name;
        let roomEvent = null;

		if (index != '-1') {
            const selectedRoomEvent = this.state.contests[index];
            roomEvent = {
                ...selectedRoomEvent,
                liveRoom: selectedRoomEvent.liveRoom || {
                    uid: selectedRoomEvent.liveRoomUID || '',
                    name: selectedRoomEvent.liveRoomName || '',
                }
            };
            roomEvent = this.convertDateToString(roomEvent);
        }


        this.setState({
            roomEvent : roomEvent,
        })
    }

    handleCreate(event) {
        let roomEvent = {
            name: '',
            liveRoom: {
                id: '',
                name: '',
                uid: ''
            },
            miniBackgroundUrl: '',
            largeBackgroundUrl: '',
            timeStart: new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T"),
            timeEnd: new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T"),
            timeShowStart: new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T"),
            isHidden: false,
            timeSendNotification: new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T"),
            isSendNotification: false,
            deepLink: '',
            mainBackgroundUrl: ''
        }
        this.setState({
            roomEvent : roomEvent,
        })
    }

    convertDateToString(roomEvent) {
        ['timeShowStart', 'timeStart', 'timeEnd', 'timeSendNotification'].forEach(field => {
            if (roomEvent[field]) {
                roomEvent[field] = new Date(roomEvent[field])
                    .toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"})
                    .replace(" ", "T");
            }
        });
        return roomEvent;
    }
   
    // Thêm hàm helper để chuyển đổi timestamp sang date string
    formatTimestamp(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    // Nhãn trạng thái duyệt. Sự kiện admin tạo không có approvalStatus → hiển thị dấu gạch.
    renderApprovalStatus(item) {
        switch (item.approvalStatus) {
            case 'PENDING':
                return <span className="badge badge-warning">Chờ duyệt</span>;
            case 'APPROVED':
                return <span className="badge badge-success">Đã duyệt</span>;
            case 'REJECTED':
                return (
                    <span className="badge badge-danger" title={item.rejectReason || ''}>
                        Từ chối
                    </span>
                );
            default:
                return <span className="text-muted">—</span>;
        }
    }

    // Thêm method để handle việc đóng modal
    handleModalClose() {
        this.setState({
            roomEvent: null
        });
    }

    render() {
        const { contests, roomEvent } = this.state;
        return (
            <>
                <ModalUpdateRoomEvent
                    roomEvent={roomEvent}
                    resetList={this.getContests}
                    onModalClose={this.handleModalClose} // Truyền callback
                >                
                </ModalUpdateRoomEvent>
                <ModalDeleteRoomEvent
                    roomEvent={roomEvent}
                    resetList={this.getContests}
                    onModalClose={this.handleModalClose} // Truyền callback
                >                
                </ModalDeleteRoomEvent>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí Sự Kiện Phòng</h1>
                        <button 
                            className="btn btn-red mb-1" 
                            data-toggle="modal" 
                            data-target="#modalUpdateRoomEvent"
                            onClick={this.handleCreate}
                            >+ Tạo Mới Sự Kiện
                        </button>
                        <select
                            className="form-control d-inline-block ml-2 mb-1"
                            style={{width: 'auto'}}
                            value={this.state.approvalStatus}
                            onChange={this.handleChangeApprovalStatus}
                        >
                            <option value="">Tất cả sự kiện</option>
                            <option value="PENDING">Chờ duyệt</option>
                            <option value="APPROVED">Đã duyệt</option>
                            <option value="REJECTED">Từ chối</option>
                        </select>
                        <table className="table table-hover">
                            <thead>
                            <tr className="text-center">
                                <th className="align-middle" scope="col">ID</th> 
                                <th className="align-middle" scope="col">Tên sự kiện</th> 
                                <th className="align-middle" scope="col">ID Phòng</th>    
                                <th className="align-middle" scope="col">Tên phòng</th>
								<th className="align-middle" scope="col">Thời gian diễn ra</th>
                                <th className="align-middle" scope="col">Hẹn giờ đăng</th>
                                <th className="align-middle" scope="col">Trạng thái</th>
                                <th className="align-middle" scope="col">Bản ghi</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                                {
                                    (contests || []).map((item, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{item.isRemoveByAdmin ? <del>{item.id}</del> : item.id}</td>
											<td className="text-center">{item.isRemoveByAdmin ? <del>{item.name}</del> : item.name}</td>
                                            <td className="text-center">{item.isRemoveByAdmin ? <del>{item.liveRoom ? item.liveRoom.uid : item.liveRoomUID}</del> : (item.liveRoom ? item.liveRoom.uid : item.liveRoomUID)}</td>
                                            <td className="text-center">{item.isRemoveByAdmin ? <del>{item.liveRoom ? item.liveRoom.name : item.liveRoomName}</del> : (item.liveRoom ? item.liveRoom.name : item.liveRoomName)}</td>
                                            <td className="text-center">{item.isRemoveByAdmin ? 
                                                <del>{this.formatTimestamp(item.timeStart)}</del> : 
                                                this.formatTimestamp(item.timeStart)
                                            }</td>
                                            <td className="text-center">{item.isRemoveByAdmin ? <del>{this.formatTimestamp(item.timeShowStart)}</del> : this.formatTimestamp(item.timeShowStart)}</td>
                                            <td className="text-center">{this.renderApprovalStatus(item)}</td>
                                            <td className="text-center">
                                                {item.playbackUrl ? (
                                                    <a
                                                        className="btn btn-primary"
                                                        href={item.playbackUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Xem bản ghi
                                                    </a>
                                                ) : (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                {
                                                    item.isRemoveByAdmin ? (
                                                        <button 
                                                        className="btn btn-info"
                                                        onClick={this.handlerUpdate}
                                                        name={index} 
                                                        data-toggle="modal" 
                                                        data-target="#modalDeleteRoomEvent"
                                                    >
                                                        Mở lại
                                                    </button>
                                                    ) : item.approvalStatus === 'PENDING' ? (
                                                        <>
                                                            <button
                                                                className="btn btn-info"
                                                                onClick={this.handlerUpdate}
                                                                name={index}
                                                                data-toggle="modal"
                                                                data-target="#modalUpdateRoomEvent"
                                                            >
                                                                Xem chi tiết
                                                            </button>&emsp;
                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={this.handlerUpdate}
                                                                name={index}
                                                                data-toggle="modal"
                                                                data-target="#modalDeleteRoomEvent"
                                                            >
                                                                Xóa
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button 
                                                                className="btn btn-success"
                                                                onClick={this.handlerUpdate}
                                                                name={index} 
                                                                data-toggle="modal" 
                                                                data-target="#modalUpdateRoomEvent"
                                                            >
                                                                Sửa
                                                            </button>&emsp;
                                                            <button 
                                                                className="btn btn-danger"
                                                                onClick={this.handlerUpdate}
                                                                name={index} 
                                                                data-toggle="modal" 
                                                                data-target="#modalDeleteRoomEvent"
                                                            >
                                                                Xóa
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                
                {/* Loading indicator đơn giản */}
                {this.state.isLoading && (
                    <div className="text-center p-3">
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                )}
                
                {/* Hiển thị thông báo khi hết dữ liệu */}
                {this.state.cursor === 'END' && (
                    <div className="text-center p-3">
                        <p className="text-muted">Đã hiển thị tất cả dữ liệu</p>
                    </div>
                )}
            </>
        );
    }
}
